import React from "react";
import { Modal, Button, Row, ConfigProvider, Image } from "antd";
import ic_profile_learner_attendance from '../assets/images/svgs/ic_profile_learner_attendance.svg';

import {
  textTitleMyLearningJourney,
  ColorPrimary,
  textDescPlayModule,
  textAlertQuit,
  textTitleHome
} from "../config/constant/color/index";
import ic_cross_attendance from '../assets/images/svgs/ic_cross_attendance.svg';


// for translate
import { useTranslation } from "react-i18next";

const ModalFailedAdmission = ({
  setUseridCheckin,
  setUserFullnameCheckin,
  setSucUserFullname,
  setSucUserDateCheckin,
  setStatusCheckin,
  submitCheckinUser,
  useridCheckin,
  statusCheckin
}) => {
  const { t, i18n } = useTranslation();


  return(
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: "16px",
            borderRadiusSM: "16px",
            borderRadiusXS: "16px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
        <Modal
            className="modal-retry-admission"
            open={statusCheckin === "failed" ? true : false}
            maskClosable="false"
            closeIcon={false}
            width={424}
            transitionName="ant-fade"
            keyboard
            centered
            footer={
              <Row
                style={{
                  justifyContent: "space-between",
                  padding: "0 32px 32px",
                  gap: "0px",
                  flexWrap: "unset",
                }}
              >
                <Button
                  key="no-logout"
                  className="btn btn-sm btn-secondary"
                  style={{
                    width: "170px",
                    borderRadius: "6px",
                    border: "1px solid " + ColorPrimary,
                    fontWeight: "500",
                    height: "48px",
                  }}
                  name="btn-cancel-logout-home"
                  onClick={() => {
                    setUseridCheckin(undefined)
                    setUserFullnameCheckin(undefined)
                    setSucUserFullname(undefined)
                    setSucUserDateCheckin(undefined)
                    setStatusCheckin(undefined)
                  }}
                >
                  {t("feature.feature_scanner.cancel")}
                </Button>
                <Button
                  key="yes-logout"
                  className="btn btn-sm btn-primary"
                  style={{
                    width: "170px",
                    borderRadius: "6px",
                    border: "1px solid " + ColorPrimary,
                    fontWeight: "500",
                    height: "48px",
                  }}
                  name="btn-yes-confirmation-admission"
                    onClick={() => submitCheckinUser(useridCheckin)}
                >
                  {t("feature.feature_scanner.retry")}
                </Button>
              </Row>
            }
          >
            <div
              style={{
                textAlign: "center",
                padding: "32px",
              }}
            >
              {/* <Image width={60} height={60} preview={false} src={ic_cross_attendance} alt="icon check attendace" /> */}
              <svg id="Group_1711180" data-name="Group 1711180" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                <circle id="Ellipse_10492" data-name="Ellipse 10492" cx="30" cy="30" r="30" fill="#e0203f"/>
                <rect id="Rectangle_448429" data-name="Rectangle 448429" width="60" height="60" fill="none"/>
                <g id="Group_1711159" data-name="Group 1711159" transform="translate(26.715 11.09)">
                  <path id="Path_1823407" data-name="Path 1823407" d="M21.094,34.631a3.226,3.226,0,1,0-2.34-.945A3.184,3.184,0,0,0,21.094,34.631Z" transform="translate(-17.81 2.94)" fill="#fff"/>
                  <path id="Path_1823408" data-name="Path 1823408" d="M21.044,30.518a2.971,2.971,0,0,0,2.2-.892,3.006,3.006,0,0,0,.883-2.208V10.494a3.1,3.1,0,1,0-6.2,0V27.418a3.049,3.049,0,0,0,3.109,3.1Z" transform="translate(-17.748 -7.393)" fill="#fff"/>
                </g>
              </svg>

              <div
                style={{
                  fontSize: 22,
                  color: textTitleHome,
                  lineHeight: "normal",
                  fontWeight: "500",
                  marginTop:24
                }}
              >
                {t("feature.feature_scanner.checkin_failed")}
              </div>

              <Row style={{color: textTitleHome,display:"flex",justifyContent:"center",flexDirection:"column",alignItems:"center"}}>
                  <div style={{fontSize:14,color:"#666666",marginTop:12,lineHeight:"normal"}}>
                    {t("feature.feature_scanner.submit_error")}
                    <br />
                    {t("feature.feature_scanner.try_again")}
                  </div>
              </Row>

            </div>
          </Modal>
    </ConfigProvider>
  )
}

export default ModalFailedAdmission;